import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}
// Supported application locales.
const SUPPORTED_LOCALES = ['en', 'es'];
// localStorage key used to persist the selected locale.
const LOCALE_STORAGE_KEY = 'app_locale';

// Function is used to Returns the locale that should be used when initializing VueI18n.
function getInitialLocale () {
  try {
    // Retrieve the user's previously selected locale from localStorage.
    const storedLocale = window.localStorage.getItem(LOCALE_STORAGE_KEY)
     // Only use the stored locale if it is one of the application's supported locales.
    if (storedLocale && SUPPORTED_LOCALES.includes(storedLocale)) {
      return storedLocale
    }
  } catch (e) {
    // localStorage unavailable (e.g. blocked by browser policy) - fall back to default
  }

  // Fall back to the locale defined in the environment configuration
  return process.env.VUE_APP_I18N_LOCALE || 'en'
}

export default new VueI18n({
  locale: getInitialLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})

export { LOCALE_STORAGE_KEY }
